<template>
    <b-button 
    variant="success" 
    @click="toInserir()" 
    v-if="mostrarBtnInserir">
        Inserir Feriado
    </b-button>
</template>

<script>
export default {
    methods: {
        toInserir() {
            this.$router.push({
                name: 'Feriado_Inserir'
            })
        }
    },

    computed: {
        mostrarBtnInserir() {
            return this.$temAcessoView('ADMIN-FERIADOS-01')
        }
    }
}
</script>